import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I prepare for a talk at an 8,000 people conference",
  "description": "",
  "published": "2018-05-21T00:00:00.000Z",
  "redirect_from": ["/blog/prepare-talk-8000-people-conference/swizec/8389"],
  "categories": "Personal, Thoughts, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`"It worked last night, I promise.”`}</em></p>
    <lite-youtube {...{
      "videoid": "GcOAzREWgFo",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Last week, I presented my crazy `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/blockchain-redux-becomes-useful-part-1/swizec/8311"
      }}>{`blockchain-redux idea`}</a>{` at WeAreDevs world congress, a conference of 8,000 people.`}</p>
    <p>{`One person called it refreshing; another said it's the first time they’d seen an idea, not a product, at a conference. 💪`}</p>
    <p>{`Of course, the next related video YouTube shows after `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=GcOAzREWgFo"
      }}>{`my vlog about preparing for the talk`}</a>{` is Tim Urban's Inside the Mind of a Master Procrastinator. 🤔`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/05/Screen_Shot_2018-05-21_at_02.50.00.png",
        "alt": null
      }}></img></p>
    <p>{`Their AI be good 😅`}</p>
    <h2 {...{
      "id": "anyway-heres-some-stuff-i-learned-at-we-are-developers-2018-→"
    }}>{`Anyway, here's some stuff I learned at `}<a parentName="h2" {...{
        "href": "https://www.wearedevelopers.com/"
      }}>{`We Are Developers 2018`}</a>{` →`}</h2>
    <ol>
      <li parentName="ol">{`You `}<em parentName="li">{`can`}</em>{` prepare a talk in 3 days at the tail end of 3 months of casual research, but you probably shouldn't`}</li>
      <li parentName="ol">{`The best talks are built like a standup routine on top of a life well lived`}</li>
      <li parentName="ol">{`Woz is cool but kind of a strange person. His insights are curious`}</li>
      <li parentName="ol">{`There are waaaaay more VR devices out there than you'd think`}</li>
      <li parentName="ol">{`Now is a good time to get into VR`}</li>
      <li parentName="ol">{`You can have 100,000 monthly active users with a few Alexa skills`}</li>
      <li parentName="ol">{`Only those Alexa skills promoted by Amazon will live. Others die`}</li>
      <li parentName="ol">{`If you are presenting, put your handle on every slide so people know how to quote you when they post photos on social media`}</li>
      <li parentName="ol">{`8000 people is too big and intimidating for effective Meet New People activities. Hard to strike up random conversations when there's nothing intrinsically in common other than "We both write code"`}</li>
      <li parentName="ol">{`Blockchain/crypto is a cult`}</li>
      <li parentName="ol">{`Vienna is beautiful. Go visit`}</li>
      <li parentName="ol">{`You write code that runs in the future, it is therefore de facto legislature`}</li>
      <li parentName="ol">{`Developers might be the only profession that doesn't even pretend to know what we're doing. We just dive right in and figure it out.`}</li>
      <li parentName="ol">{`Woz says managing is easier than coding, and it's unclear whether that was a joke, honest opinion, or pandering to the crowd`}</li>
      <li parentName="ol">{`Also company values without action are bullshit`}</li>
      <li parentName="ol">{`Oh, and Angular is doing some iiiiinteresting things with automatic code mods to make upgrading JavaScripts and such easier`}</li>
    </ol>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Developers don’t even pretend to knoe what we’re doing. We dive in and fix problems with hammers and anger`}<br parentName="p"></br><br parentName="p"></br>{`~ `}<a parentName="p" {...{
          "href": "https://twitter.com/spolsky"
        }}>{`@spolsky`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/WeAreDevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#WeAreDevs`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/lEy6QwxHJ4"
        }}>{`pic.twitter.com/lEy6QwxHJ4`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/997487063221047328"
      }}>{`May 18, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Another thing I noticed at `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/WeAreDevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#WeAreDevs`}</a>{`: Everything is English. Nobody is English.`}<a parentName="p" {...{
          "href": "https://twitter.com/ryanflorence"
        }}>{`@ryanflorence`}</a>{` once said how impressed he is by folks’ tech talks in their 2nd language.`}<br parentName="p"></br><br parentName="p"></br>{`In Europe it’s the norm. Speaker ain’t native, audience ain’t native, it all works.`}<br parentName="p"></br>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/impressive?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#impressive`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/997429978944950273"
      }}>{`May 18, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`You can have 100,000 monthly active users with Alexa skills 😳`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/997425060850921473"
      }}>{`May 18, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Protip for speakers I learned at `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/WeAreDevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#WeAreDevs`}</a>{`: `}<br parentName="p"></br><br parentName="p"></br>{`Put your handle on every slide. We want to quote you and we forget your name in 5 seconds.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/997426249646649344"
      }}>{`May 18, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Company values without action are bullshit `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/WeAreDevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#WeAreDevs`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/oIA4hYA4kC"
        }}>{`pic.twitter.com/oIA4hYA4kC`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/997400957775482881"
      }}>{`May 18, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Software history is a pendulum between server and client`}<a parentName="p" {...{
          "href": "https://twitter.com/stephenfluin"
        }}>{`@stephenfluin`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/WeAreDevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#WeAreDevs`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/HQ2eRwlnem"
        }}>{`pic.twitter.com/HQ2eRwlnem`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/997407124727611392"
      }}>{`May 18, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Wow there’s a lot more VR out there than I thought. Millions of devices `}<a parentName="p" {...{
          "href": "https://t.co/q5cP2U56de"
        }}>{`pic.twitter.com/q5cP2U56de`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/996742469147680769"
      }}>{`May 16, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Engineering is a young person’s game, you need mental energy. After a while you hsve to go into management, something easy.`}<br parentName="p"></br><br parentName="p"></br>{`~ Wozniak`}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/WeAreDevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#WeAreDevs`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/996668145300639744"
      }}>{`May 16, 2018`}</a></blockquote>
    <h2 {...{
      "id": "you-get-a-big-room-if-you-put-enough-buzzwords-in-your-talk-title"
    }}>{`You get a big room if you put enough buzzwords in your talk title.`}</h2>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`That was a big room. Sweat poring down my back 😅`}<br parentName="p"></br><br parentName="p"></br>{`I hope my crazy idea gave you some ideas `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/WeAreDevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#WeAreDevs`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/ogDRt9ZxmB"
        }}>{`pic.twitter.com/ogDRt9ZxmB`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/997470708396675072"
      }}>{`May 18, 2018`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "und",
        "dir": "ltr"
      }}><a parentName="p" {...{
          "href": "https://twitter.com/Swizec"
        }}>{`@swizec`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/wearedevs?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#wearedevs`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/wearedevelopers?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#wearedevelopers`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/blockchain?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#blockchain`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/web?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#web`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/redux?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#redux`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/n20lOyhy5V"
        }}>{`pic.twitter.com/n20lOyhy5V`}</a></p>{`— Dariusz Kalbarczyk (@ngKalbarczyk) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/ngKalbarczyk/status/997469861591879680"
      }}>{`May 18, 2018`}</a></blockquote>
    <p>{`Guess now I have to build the stuff I promised in my talk.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      